// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"5079961a","453":"822b2e72","632":"19ad7c0a"}[chunkId] + ".chunk.js";
};